import * as React from "react";
import { CustomSubmitButton } from 'soprasteria-ui-library';
import { useAuth } from "../../../../App";
import { OrthodonticReferralResponseApi } from "../../../../api/OrthodonticReferralResponseApi";

interface IOrthodonticReferralSendTreatmentTwoButton {
    orthodonticReferralId?: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getOrthodonticReferral: (id: number) => void;
}

export const OrthodonticReferralSendTreatmentTwoButton: React.FunctionComponent<IOrthodonticReferralSendTreatmentTwoButton> = ({ orthodonticReferralId, changeSuccessMessage, changeErrorMessage, getOrthodonticReferral }) => {

    const auth = useAuth();
    const api = new OrthodonticReferralResponseApi(auth);
    const [isOrthodonticReferralSending, setIsOrthodonticReferralSending] = React.useState<boolean>(false);

    const sendOrthodonticReferral = () => {
        if (orthodonticReferralId) {
            setIsOrthodonticReferralSending(true);
            api.sendToProvningskonsult(orthodonticReferralId, () => {
                changeSuccessMessage("Ortodontiremissen har skickats till prövningskonsult");
                getOrthodonticReferral(orthodonticReferralId);
            }, (message) => {
                changeErrorMessage(message);
            }, () => setIsOrthodonticReferralSending(false));
        }
    }

    return (
        <CustomSubmitButton onButtonSubmit={sendOrthodonticReferral} isLoading={isOrthodonticReferralSending}>Skicka till prövningskonsult</CustomSubmitButton>
    );
}